import styled from 'styled-components';
import {
  Accordion as SemanticAccordion,
  Icon as SemanticIcon,
} from 'semantic-ui-react';
import { Text as TextLayoutComponent, Button as ButtonLayoutComponent } from '@playbookux/playbook-web-core';

const Accordion = styled(SemanticAccordion)``;

const Icon = styled(SemanticIcon)`
  cursor: pointer;
`;

const TaskNumberContainer = styled(TextLayoutComponent.Bold)`
  color: ${(props) => props.theme.color.textSecondary};
  font-weight: 500;
  font-size: 14px;
  text-transform: capitalize;
  cursor: default;
  width: fit-content;
  min-width: 100px;
`;

const AccordionTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  cursor: default;
`;

const Container = styled.div`
  margin-bottom: 20px
`;

const NowPlaying = styled(ButtonLayoutComponent)`
  &.ui.button {
    background: #D6FFC1;
    border-radius: 4px;
    color: #487717;
    font-size: 12px;
    font-weight: 500;
    padding: 5px;
    box-shadow: unset;

    :hover {
      background: #D6FFC1;
      color: #487717;
    }
    cursor: default;
  }
`;

const PlayIcon = styled(SemanticIcon)`
  color: #477AE9;
  font-size: 20px !important;
  margin: auto !important;
  cursor: pointer;
`;

const ContainerLeft = styled.div`
  min-width: 100px;
  display: flex;
  align-items: center;
`;

const PlayText = styled(TextLayoutComponent.Bold)`
  color: ${(props) => props.theme.color.primary};
  font-weight: 500;
  font-size: 14px;
  text-transform: capitalize;
  cursor: default;
  width: fit-content;
  margin-right: 5px;
  cursor: pointer;
`;

const PlayContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const ContainerRight = styled.div`
`;

export {
  Container,
  Accordion,
  Icon,
  TaskNumberContainer,
  AccordionTitleContainer,
  ContainerLeft,
  ContainerRight,
  NowPlaying,
  PlayIcon,
  PlayText,
  PlayContainer,
};
